import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class GesamtenergieverbrauchProGebaeude extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    kanton_id: number | null = null;
    jahr: number | null = null;
    egid: number | null = null;
    bfs_gemeindenummer: number | null = null;
    nutzungsart_id: number | null = null;
    bauperiode_id: number | null = null;
    energiebezugsflaeche: number | null = null;
    waermeerzeuger_heizung_1: number | null = null;
    waermeerzeuger_heizung_2: number | null = null;
    energie_waermequelle_heizung_1: number | null = null;
    energie_waermequelle_heizung_2: number | null = null;
    waermeerzeuger_warmwasser_1: number | null = null;
    waermeerzeuger_warmwasser_2: number | null = null;
    energie_waermequelle_warmwasser_1: number | null = null;
    energie_waermequelle_warmwasser_2: number | null = null;
    nutzungsgrad_heizung_1: number | null = null;
    nutzungsgrad_heizung_2: number | null = null;
    nutzungsgrad_warmwasser_1: number | null = null;
    nutzungsgrad_warmwasser_2: number | null = null;
    e_gebaeudekoordinate: number | null = null;
    n_gebaeudekoordinate: number | null = null;
    ist_grossverbraucher: boolean | null = null;
    ist_waermeverbund: boolean | null = null;
    grossverbraucher_ids: number[] | null = null;
    grossverbraucher_energieverbrauch: string | null = null;
    name_grossverbraucher: string | null = null;
    endenergie_beruecksichtigen: boolean | null = null;
    waermebezug_von_grossverbraucher_oder_waermeverbund: boolean | null = null;
    waermebezug_id: number | null = null;

    // view fields
    nutzungsart: string | null = null;
    kanton: string | null = null;
    kanton_kuerzel: string | null = null;
    energieverbrauch_heizung: number | null = null;
    energieverbrauch_warmwasser: number | null = null;
    energieverbrauch_gesamt: number | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'GesamtenergieverbrauchProGebaeude';
    }
}

export async function createNewGesamtenergieverbrauchProGebaeude(): Promise<GesamtenergieverbrauchProGebaeude> {
    const model = createModel(GesamtenergieverbrauchProGebaeude, {});
    await model.save();
    return model;
}

export class GesamtenergieverbrauchProGebaeudeCollection extends BaseCollection<GesamtenergieverbrauchProGebaeude> {
    protected modelCls = GesamtenergieverbrauchProGebaeude;

    public getModelClassName(): string {
        return 'GesamtenergieverbrauchProGebaeude';
    }
}
